import { isEmpty } from "./isEmpty";

/**
 * Returns if the given {@link value} is not empty.
 */
export const isNotEmpty = (value: string): boolean => {
  return !isEmpty(value);
};
